import {queryOptions} from '@tanstack/react-query';

import {keys} from '@queries/keys';

import {getWorkerStatus} from './getWorkerStatus';

/** Статус воркера живой — перечитываем раз в минуту, пока экран открыт */
export const workerStatusQueryOptions = () =>
  queryOptions({
    queryKey: keys.system.worker(),
    queryFn: getWorkerStatus,
    refetchInterval: 60_000,
  });
